import { cn } from "@/lib/cn";

export const QuoteBlock = ({ quote, attribution, role, className, testId }) => {
  return (
    <figure
      data-testid={testId || "quote-block"}
      className={cn("flex flex-col gap-4 border-l border-border pl-6", className)}
    >
      <blockquote className="text-xl font-normal leading-relaxed tracking-tight text-foreground sm:text-2xl">
        &ldquo;{quote}&rdquo;
      </blockquote>
      {(attribution || role) && (
        <figcaption className="text-sm">
          {attribution && (
            <span className="font-medium text-foreground">{attribution}</span>
          )}
          {role && (
            <span className="text-muted-foreground">
              {attribution ? " · " : ""}
              {role}
            </span>
          )}
        </figcaption>
      )}
    </figure>
  );
};

export default QuoteBlock;
